import {
  IRvdGetRequestParams,
  IRvdGetResponsePaginated,
  TLoadRvdRequest,
  TRvdCreateRequest,
  TRvdGetResponse,
  TRvdTakeToWorkRequest,
  TRvdUpdateRequest,
  TRvdUserCreateRequest,
  TRvdUserUpdateRequest,
  TUserRvdInfo,
  TUserRvdInfoPaginated,
  UsersToCheckRequestRvd,
} from 'shared/types/rvd.types';
import { ICreateNewsResponse } from 'shared/types/news.types';
import { edpApiV1 } from './index';

export const rvdApi = edpApiV1.injectEndpoints({
  endpoints: build => ({
    getRvd: build.query<IRvdGetResponsePaginated, IRvdGetRequestParams>({
      query: params => ({ url: '/v1/admin/additional_income/wow', method: 'GET', params }),
      providesTags: ['rvd'],
    }),
    getRvdById: build.query<TRvdGetResponse, { id: number }>({
      query: params => ({ url: '/v1/admin/additional_income/wowById', method: 'GET', params }),
      providesTags: ['rvd'],
    }),
    updateRvd: build.mutation<ICreateNewsResponse, TRvdUpdateRequest>({
      query: rvd => ({
        url: `/v1/admin/additional_income/wow`,
        method: 'PATCH',
        body: rvd,
      }),
      invalidatesTags: ['rvd'],
    }),
    createRvd: build.mutation<ICreateNewsResponse, TRvdCreateRequest>({
      query: body => ({
        url: `/v1/admin/additional_income/wow`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['rvd'],
    }),
    deleteRvd: build.mutation<string, { id: number }>({
      query: params => ({
        url: `/v1/admin/additional_income/wow`,
        method: 'DELETE',
        params,
      }),
      invalidatesTags: ['rvd'],
    }),
    loadRvd: build.mutation<ICreateNewsResponse, TLoadRvdRequest>({
      query: rvd => ({
        url: `/v1/admin/additional_income/status`,
        method: 'PATCH',
        body: rvd,
        responseHandler: response => response.text(),
      }),
      invalidatesTags: ['rvd'],
    }),
    createRvdUser: build.mutation<ICreateNewsResponse, TRvdUserCreateRequest>({
      query: body => ({
        url: `/v1/admin/additional_income/wow_user`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['rvd_users', 'rvd'],
    }),
    updateRvdUser: build.mutation<ICreateNewsResponse, TRvdUserUpdateRequest>({
      query: body => ({
        url: `/v1/admin/additional_income/wow_user`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['rvd_users', 'rvd'],
    }),
    deleteRvdUser: build.mutation<string, { id: number }>({
      query: params => ({
        url: `/v1/admin/additional_income/wow_user`,
        method: 'DELETE',
        params,
      }),
      invalidatesTags: ['rvd_users', 'rvd'],
    }),
    getRvdUsers: build.query<
      TUserRvdInfoPaginated,
      { wowId: number; page: number; size: number; personnelNumber?: string }
    >({
      query: params => ({
        url: `/v1/admin/additional_income/wow_user`,
        method: 'GET',
        params,
      }),
      providesTags: ['rvd_users'],
    }),
    rvdTakeToWork: build.mutation<string, TRvdTakeToWorkRequest>({
      query: ({ hrId, wowId }) => {
        const body = hrId ? { hrId } : {};
        return {
          url: `/v1/admin/additional_income/wow/${wowId}/take-to-work`,
          method: 'PATCH',
          body,
        };
      },
      invalidatesTags: ['rvd'],
    }),
    checkRvdUser: build.mutation<TUserRvdInfo[], UsersToCheckRequestRvd>({
      query: body => ({
        url: `/v1/admin/additional_income/wow_user/check`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['rvd_users', 'rvd'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateRvdMutation,
  useGetRvdQuery,
  useLazyGetRvdQuery,
  useUpdateRvdMutation,
  useGetRvdByIdQuery,
  useLazyGetRvdByIdQuery,
  useCreateRvdUserMutation,
  useDeleteRvdMutation,
  useDeleteRvdUserMutation,
  useUpdateRvdUserMutation,
  useGetRvdUsersQuery,
  useLazyGetRvdUsersQuery,
  useLoadRvdMutation,
  useRvdTakeToWorkMutation,
  useCheckRvdUserMutation,
} = rvdApi;
